/* Click-and-drag for desktop product sliders (.slider--desktop), like swiping on a phone.
   Mouse only — touch keeps the browser's native swipe. Snaps to the nearest card on release,
   and a drag never counts as a click on the card's link. */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var DRAG_THRESHOLD = 6; // px before a press becomes a drag (so normal clicks still work)

  function nearestSlideLeft(el) {
    var slides = el.children;
    if (!slides.length) return el.scrollLeft;
    var base = slides[0].offsetLeft;
    var best = 0;
    var bestDist = Infinity;
    for (var i = 0; i < slides.length; i++) {
      var left = slides[i].offsetLeft - base;
      var dist = Math.abs(left - el.scrollLeft);
      if (dist < bestDist) { bestDist = dist; best = left; }
    }
    return Math.min(best, el.scrollWidth - el.clientWidth);
  }

  function bind(el) {
    if (el.dataset.dragReady) return;
    el.dataset.dragReady = 'true';
    var down = false;
    var dragged = false;
    var startX = 0;
    var startLeft = 0;

    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true;
      dragged = false;
      startX = e.clientX;
      startLeft = el.scrollLeft;
    });

    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!dragged) {
        if (Math.abs(dx) < DRAG_THRESHOLD) return;
        dragged = true;
        el.classList.add('is-dragging');
      }
      el.scrollLeft = startLeft - dx;
    });

    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      if (!dragged) return;
      var target = nearestSlideLeft(el);
      el.classList.remove('is-dragging');
      el.scrollTo({
        left: target,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
      // The click that follows a drag must not open the product.
      setTimeout(function () { dragged = false; }, 0);
    });

    el.addEventListener('click', function (e) {
      if (dragged) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    // Stop the browser's own image/link drag ghost from hijacking the gesture.
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function init(root) {
    (root || document).querySelectorAll('.slider--desktop').forEach(bind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
